import { PortalType } from "@studyportals/domain-client";

export default class PathUtils {
	static isInSearchPage(): boolean {
		const path = window.location.pathname;
		return path.includes("/search");
	}
	static IsUniversitySearch(): boolean {
		const path = window.location.pathname;
		return path.includes("/search/universities");
	}
	static isScholarshipSearch(): boolean {
		const path = window.location.pathname;
		return path.includes("/search/scholarships");
	}
	static portalPathFragment(): string {
		switch (window.PortalType) {
		case PortalType.BACHELOR:
			return "bachelor";
		case PortalType.MASTER:
			return "master";
		case PortalType.PHD:
			return "phd";
		case PortalType.SHORT:
			return "course";
		case PortalType.DISTANCE_LEARNING:
			return "distance-learning";
		default:
			return "";
		}
	}
}